export default {
  id: null,
  dataInicial: null,
  mensagemForaHorario: null,
  mensagemBoasVindas: null,
  mensagemAssumir: null,
  mensagemTransferir: null,
  mensagemFinalizar: null,
  mensagemNps: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/mensagensautomaticasmodel.js